var mapboxgl = require('mapbox-gl');
var $ = require("jquery");
const axios = require('axios');

if(document.getElementById('map')) {

	$('.developments-map').on("click", function() {
		$(this).addClass('active');
	});

	$('.developments-map').on('mouseleave', function () {
		$(this).removeClass('active');
	});


	if (location.protocol !== 'https:') {
		var base_url = 'http://' + location.hostname;
	}
	else {
		var base_url = 'https://' + location.hostname;
	}

	var geoURL = base_url + "/developments.geojson";
	


/* ====================== MAP BITS ======================  */
	mapboxgl.accessToken = 'pk.eyJ1IjoiYm94ZWRyZWQiLCJhIjoiY2s3b2wxa3ljMDlibjNnbzI5dWM5OTV0aCJ9.HngfEMhn4u34Q1DwaPpdrg';
	var map = new mapboxgl.Map({
		container: 'map',
		style: 'mapbox://styles/mapbox/streets-v11',
		center: [-1.1581, 52.9548],
		zoom: 6.2
	});

	map.addControl(new mapboxgl.NavigationControl({
		showCompass: false
	}), 'bottom-right');



	map.on('style.load', function(){
		var highCount = 75,
        	lowCount = 15;

		map.addSource('developments', {
			type: "geojson",
			data: geoURL,
			cluster: true,
			clusterMaxZoom: 14, // Max zoom to cluster points on
			clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
		});

		$.getJSON(geoURL, function (geojson) {
		    geojson.features.forEach(function (marker) {
		       	var comingsoon = marker.properties.comingsoon;

		       	var el = document.createElement('div');
		       	el.className = 'marker';

		       	if( comingsoon == true) {
		       		$(el).addClass('coming-soon');
		       	}

				el.addEventListener('click', function() {
					var slug = marker.properties.slug;

				  	map.flyTo({center: marker.geometry.coordinates, zoom: 10});
					$('.development-popup').removeClass('active')
					$('.development-popup[development-related='+slug+']').addClass('active');
				});

				new mapboxgl.Marker(el, {anchor: 'bottom'})
				.setLngLat(marker.geometry.coordinates)
				.addTo(map);
		    });
		});

		$('.development-popup .close').on("click", function() {
			$('.development-popup').removeClass('active');
			map.flyTo({center: [-1.1581, 52.9548],zoom: 6.2});
		});
	});
};
